import React from 'react';
import './MediaCenter.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';

const testimonials = [
    {
        rating: "★★★★★",
        title: "Thank you, RiseFX! I’ll continue investing with you.",
        text: "RiseFX has been my reliable Forex platform for 1.5 years. Their prompt, 24/7 support is excellent – always responsive, even at odd hours. Withdrawals are super fast—I’ve withdrawn money 7+ times, and it always reaches my bank within 4 hours. Their supportive and professional team makes Forex trading more manageable. I highly recommend RiseFX as a trusted platform.",
        name: "- DENIS M SILVA, Udupi, Karnataka",
    },
    {
        rating: "★★★★☆",
        // title: "Best Shopping Experience!",
        text: "RISE FX's services are very good, and we have never faced any issues with transactions. Their payment process is also excellent, and we receive complete and proper service from them, which makes us satisfied.We wish for RISEFX to always be recognized for its best services.",
        name: "- NEELESH KUMAR BHARGAVA, Biaora, Madhya pradesh",
    },
    {
        rating: "★★★★★",
        // title: "Absolutely Worth It!",
        text: "I have been using RISEFX for a while now, and I must say it has been a great experience! The platform is user-friendly, and the execution speed is impressive. Spreads are competitive, and withdrawals are processed smoothly without any hidden charges",
        name: "- WINNY CUTINHA, Dubai, UAE",
    },
    {
        rating: "★★★★☆",
        title: "Go for it and trade with confidence! ✅",
        text: "Hello friends! Are you into Forex trading? Choose RISE FX for a confident and reliable experience. They offer strong support, excellent backup, and incredible service—you can trust them completely.Whether you're making small or big investments, using the RISE FX platform you grow your money. you’re in great hands to move forward.",
        name: "- SELVARANGAN, Coimbatore, Tamil Nadu",
    },
    {
        rating: "★★★★★",
        // title: "Outstanding Service!",
        text: "One of the best things about RISEFX is their customer support—they are always responsive and helpful whenever I have a query. The transparency in pricing and the overall trading environment make it a trustworthy brokerage",
        name: "- MUKESH KUMAR, Delhi",
    },
    {
        rating: "★★★★★",
        text: 'Hello everyone, I would like to share my experience with RiseFX. I have been using RiseFX for the past six months and, I’m very satisfied with their services. I’ve used many brokers before, but RiseFX has truly stood out. Pay-ins are processed smoothly and at any time—even late at night, around 12:00 AM or 2:30 AM, my requests have been handled efficiently. In most cases, I received my pay-outs within 30 mins to an hour. Whenever I had any queries, They responded promptly and resolved everything. I’ve dealt with many brokers, but none have provided the kind of service and reliability like RiseFX. I’m truly happy with their support and would like to thank the Risefx team for their excellent assistance.',
        name: "Muhammad Zainuddin Sohail - Charminar, Hyderabad",
    },
];

const MediaCenter = () => {
    return (
        <div className='media-container'>
            <div className='media-section-1'>
                <p className='section-highlight'>Testimonial</p>
                <h1 className='section-heading'>What Our Customers Say</h1>
            </div>
            <Swiper
                slidesPerView={4}
                spaceBetween={20}
                loop={true}
                autoplay={{
                    delay: 8000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                    },
                    640: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                }}
                modules={[Autoplay]}
                className="media-section-2"
            >

                {testimonials.map((item, index) => (
                    <SwiperSlide key={index} className="media-card">
                        <div className='media-card-1'>
                            <div className='media-content'>
                                <div className='rating-stars'>{item.rating}</div>
                                <p className='title-para'>{item.text}</p>
                                {/* <h2 className='title-link'>{item.title}</h2> */}
                            </div>
                            <div className='media-profile'>
                                <p className='profile-name'>{item.name}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default MediaCenter;
